import { render } from "./Child-List-Item-Birthday.vue?vue&type=template&id=19a4b7f4&scoped=true"
import script from "./Child-List-Item-Birthday.vue?vue&type=script&lang=js"
export * from "./Child-List-Item-Birthday.vue?vue&type=script&lang=js"

import "./Child-List-Item-Birthday.vue?vue&type=style&index=0&id=19a4b7f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a4b7f4"]])

export default __exports__